import { message } from "antd";
import axiosInstance from "../axiosInstance";

import {
	FETCH_SURVEYS_REQUEST,
	FETCH_SURVEYS_SUCCESS,
	FETCH_SURVEYS_FAIL,
	FETCH_SURVEY_REQUEST,
	FETCH_SURVEY_SUCCESS,
	FETCH_SURVEY_FAIL,
	DOWNLOAD_SURVEYS_REQUEST,
	DOWNLOAD_SURVEYS_SUCCESS,
	DOWNLOAD_SURVEYS_FAIL,
	RESET_DOWNLOAD_CSV,
} from "../constants/survey";

const fetchSurveys = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_SURVEYS_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/surveys", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_SURVEYS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_SURVEYS_FAIL, payload: errorMessage });
	}
};

const fetchSurvey = (id) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: FETCH_SURVEY_REQUEST });

	try {
		const { data } = await axiosInstance.get(`/admin/surveys/${id}`, {
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({ type: FETCH_SURVEY_SUCCESS, payload: data.data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: FETCH_SURVEY_FAIL, payload: errorMessage });
	}
};

const downloadSurvey = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();
	dispatch({ type: DOWNLOAD_SURVEYS_REQUEST });

	try {
		const { data } = await axiosInstance.post(
			`/admin/surveys/download`,
			params,
			{
				headers: {
					Authorization: "Bearer " + adminInfo.authToken,
				},
			},
		);
		dispatch({ type: DOWNLOAD_SURVEYS_SUCCESS, payload: data });
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		message.error(errorMessage);
		dispatch({ type: DOWNLOAD_SURVEYS_FAIL, payload: errorMessage });
	}
};

const resetDownloadCsv = () => (dispatch) => {
	dispatch({ type: RESET_DOWNLOAD_CSV });
};

export { fetchSurveys, fetchSurvey, downloadSurvey, resetDownloadCsv };
